<template>
  <section class="px-5">
    <div class="max-w-230 mx-auto">
      <TitleBlock :title="content.title" class="ml-0 mb-5" />
      <RawHtml :html="content.content" :section_bg="content.background" />
      <OptionalButtons :buttons="content.buttons" class="mt-6 md:mt-8" />
    </div>
  </section>
</template>

<script lang="ts">
import { OptionalButtons, TitleBlock } from "@/components/blocks";
import { RawHtml } from "@/components/helpers";

export default {
  name: "RichTextSection",
  components: { OptionalButtons, RawHtml, TitleBlock },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>
